import { render, staticRenderFns } from "./PushPopin.vue?vue&type=template&id=edc2b0c4&scoped=true"
import script from "./PushPopin.vue?vue&type=script&lang=js"
export * from "./PushPopin.vue?vue&type=script&lang=js"
import style0 from "./PushPopin.vue?vue&type=style&index=0&id=edc2b0c4&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edc2b0c4",
  null
  
)

export default component.exports